import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@/components/ui/dropdown-menu';
import { cn } from '@/utils';
import { SupabaseClient, User } from '@supabase/supabase-js';
import { BugIcon, LogOut, User as UserIcon } from 'lucide-react';

export const getInitials = (user: User) => {
  let result = 'X';
  if (user?.user_metadata?.name) {
    result = user.user_metadata?.name
      .split(' ')
      .map((name: string) => name[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  } else if (user?.email) {
    result = user.email.split('@')[0].toUpperCase().slice(0, 2);
  }
  return result;
};

export default function ProfileButton(props: {
  user: User | null;
  supabase: SupabaseClient;
  setShowSettings: (showSettings: boolean) => void;
  printFPS?: () => void;
  className?: string;
  icon?: React.ReactNode;
}) {
  const { user, supabase, icon, setShowSettings, printFPS } = props;
  return (
    <div>
      <DropdownMenu>
        <DropdownMenuTrigger
          className={cn(
            'text-xs flex flex-col items-center justify-center rounded-full w-8 h-8 p-0 border outline-none ring-0 border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700',
            props.className
          )}
        >
          <h2 className="font-medium text-gray-700 dark:text-gray-300 group-hover:text-black dark:group-hover:text-white whitespace-nowrap">
            {icon ?? (user ? getInitials(user) : 'X')}
          </h2>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-40" side="bottom" align="end">
          <DropdownMenuItem
            onClick={() => setShowSettings(true)}
            className="flex items-center cursor-pointer"
          >
            <UserIcon className="w-3 h-3 mr-2" />
            Account
          </DropdownMenuItem>
          {process.env.NODE_ENV === 'development' ? (
            <DropdownMenuItem
              onClick={() => {
                if (printFPS) {
                  printFPS();
                }
              }}
              className="flex items-center cursor-pointer"
            >
              <BugIcon className="w-3 h-3 mr-2" />
              FPS
            </DropdownMenuItem>
          ) : null}
          <DropdownMenuItem
            onClick={() => {
              console.log('logout');
              supabase.auth.signOut();
              // window.umami?.track("Avatar - Sign out", {});
              setTimeout(() => {
                window.location.href = '/';
              }, 1000);
            }}
            className="flex items-center cursor-pointer"
          >
            <LogOut className="w-3 h-3 mr-2" />
            Logout
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
